import { registerAction } from '../../Action'

const RESET_WS_LAST_FRAME = 'RESET_WS_LAST_FRAME'

const reducer = (state = {}) => ({
  ...state,
  ws_frames: {
    ...state.ws_frame,
    lastFrame: {},
  },
})

const resetWSLastFrame = registerAction(RESET_WS_LAST_FRAME, { reducer })

export default resetWSLastFrame
